module.exports = __webpack_public_path__ + "static/RUmobSlide9-d66845721449f8dac14e685e95cb7027.jpg";